<template>
  <div>
    <h1>Nova de Contrapartida</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("contrapartidas", ["contrapartida"]),
  },
  methods: {
    ...mapActions("contrapartidas", ["ActionNewContrapartida"]),
    loadData(id) {
      this.$router.push({ name: "contrapartidas_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewContrapartida();
  },
};
</script>

<style></style>
